import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable()
export class ApplicationContextService {

  constructor(
    private storage: StorageService
  ) { }

  public isApplicationEmbedded = (): boolean => {
    if (window.location.href.indexOf('embeddedContext=') != -1) {
      return true;
    }

    return window.location != window.parent.location ? true : false;
  }

  public getBrandContextFromUrl() {
    //will be a 4 character string
    const brandContextIndex = window.location.href.indexOf('brandContext=');
    let brandContextFromUrl;
    if (brandContextIndex != -1) {
      brandContextFromUrl = window.location.href.slice(brandContextIndex + 13, brandContextIndex + 17).toUpperCase();
      return brandContextFromUrl;
    }else{
      return 'none';
    }
  }

  public isPublic = (): boolean => {
    if (window.location.href.indexOf('publicContext=true') != -1) {
      return true;
    }

    return false;
  }

  public onSkuMatchingTool = (): boolean => {
    if (window.location.href.indexOf('sku-matching-tool') != -1) {
      return true;
    }

    return false;
  }

  public isJwtContext = (): boolean => {

    if (this.isApplicationEmbedded() == false) {
      return false;
    }

    if (window.location.href.indexOf('jwtContext=true') != -1) {
      return true;
    }

    return false;

  }

  public isSummaryAndTabsRequired = (): boolean => {
    return window.location.href.indexOf('hideSummaryAndTabs') == -1 ? true : false
  }

  public isFrameBackgroundRequired = (): boolean => {
    return window.location.href.indexOf('hideFrameBackground') == -1 ? true : false
  }

  public isContainerPaddingRequired = (): boolean => {
    return window.location.href.indexOf('hideContainerPadding') == -1 ? true : false
  }

  public hideTitleInParent = (): boolean => {
    return window.location.href.indexOf('hideTitle') == -1 ? false : true
  }

  public parentFrameJwt = (): string | undefined => {

    if (this.isJwtContext() == false) {
      return undefined;
    }

    if (window.location.href.indexOf('jwToken=') == -1) {
      return undefined;
    }

    let jwt = window.location.href.substring(window.location.href.indexOf('jwToken=') + 8, window.location.href.indexOf('jwToken-end'))
    let jwtRefreshToken = window.location.href.substring(window.location.href.indexOf('jwtRefreshToken=') + 16, window.location.href.indexOf('jwtRefreshToken-end'))
    this.storage.setStorageItem('sng-jwToken', jwt)
    this.storage.setStorageItem('sng-jwtRefreshToken', jwtRefreshToken)
    return jwt;

  }


  public parentFrameJwtRefreshToken = (): string | undefined => {

    if (this.isJwtContext() == false) {
      return undefined;
    }

    if (window.location.href.indexOf('jwtRefreshToken=') == -1) {
      return undefined;
    }

    let jwt = window.location.href.substring(window.location.href.indexOf('jwtRefreshToken=') + 16, window.location.href.indexOf('jwtRefreshToken-end'))

    return jwt;

  }

  public getBranchCodeFromUrl(returnBranchCountryCode?: boolean) {
    const branchIndex = window.location.href.indexOf('branch=');
    let branchFromUrl;
    if (branchIndex != -1) {
      branchFromUrl = window.location.href.slice(branchIndex + 7, branchIndex + 9).toUpperCase();
    }else{
      if(returnBranchCountryCode) {
        return 'GB';
      }
      return 'SNG';
    }
    if (branchFromUrl == 'UK') {
      if(returnBranchCountryCode) {
        return 'GB';
      }
      return 'SNG';
    } else if (branchFromUrl == 'US') {
      if(returnBranchCountryCode) {
        return 'US';
      }
      return 'BAU';
    } else if (branchFromUrl == 'FR') {
      if(returnBranchCountryCode) {
        return 'FR';
      }
      return 'SNF';
    } else if (branchFromUrl == 'NL') {
      if(returnBranchCountryCode) {
        return 'NL';
      }
      return 'SNH';
    } else if (branchFromUrl == 'DE') {
      if(returnBranchCountryCode) {
        return 'DE';
      }
      return 'SNH';
    } else {
      if(returnBranchCountryCode) {
        return 'GB';
      }
      return 'ALL';
    }
  }
  public getRawBranchCodeFromUrl() {
    const branchIndex = window.location.href.indexOf('branch=');
    let branchFromUrl;
    if (branchIndex != -1) {
      branchFromUrl = window.location.href.slice(branchIndex + 7, branchIndex + 9).toUpperCase();
      return branchFromUrl;
    }else{
      return 'UK';
    }
  }

  public getLanguageCodeFromUrl(): string {
    const languageIndex = window.location.href.indexOf('language=');
    let languageFromUrl;

    if (languageIndex != -1) {
      languageFromUrl = window.location.href.slice(languageIndex + 9, languageIndex + 11);
    }

    return languageFromUrl ? languageFromUrl.toLowerCase() : 'en';
  }

  public getUrlParam = (param: string): boolean => {

    if(window.location.href.indexOf(param) != -1){
      return true
    }

    return false;
  }

  public isReactingToAppSizeRequired = (): boolean => {
    return window.location.href.indexOf('disableAppSizeReaction') == -1 ? true : false
  }

}